import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { pageMeta, ldScripts, breadcrumbLd, serviceLd, faqLd } from "@/lib/seo";
import { abMeta } from "@/content/metaExperiments";
import { siteConfig } from "@/config/site";


export const Route = createFileRoute("/services/$slug/")({
  loader: async ({ params }) => {
    const { getService } = await import("@/content/services");
    const service = getService(params.slug);
    if (!service) throw notFound();
    return { service };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) {
      return {
        meta: [
          { title: `Service not found — ${siteConfig.name}` },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    const s = loaderData.service;
    const path = `/services/${params.slug}/`;
    const ab = abMeta(path, { title: s.metaTitle, description: s.metaDescription });
    const base = pageMeta({
      path,
      title: ab.title,
      description: ab.description,
      image: `${siteConfig.origin}/og-image.png`,
      type: "article",
      keywords: [
        s.title,
        `${s.title} ${siteConfig.contact.address.city}`,
        `${s.title} ${siteConfig.contact.address.state}`,
        `${s.title} services`,
        `${s.title} agency`,
        siteConfig.name,

      ],
    });
    return {
      ...base,
      scripts: ldScripts(
        serviceLd({ name: s.title, description: s.metaDescription, path }),
        breadcrumbLd([
          { name: "Home", path: "/" },
          { name: "Services", path: "/services" },
          { name: s.title, path },
        ]),
        ...(s.faqs?.length ? [faqLd(s.faqs)] : []),
      ),
    };
  },
  component: ServiceDetail,
  notFoundComponent: () => (
    <div>
      <section className="container-page py-32 text-center">
        <h1 className="font-display text-4xl">Service not found</h1>
        <Link to="/services/" className="mt-6 inline-block text-primary">
          ← All services
        </Link>
      </section>
    </div>
  ),
});

function ServiceDetail() {
  const { service } = Route.useLoaderData();
  return <ServicePageTemplate service={service} />;
}
